import { initiateCheckout, removeCard } from "./Effects/billingDetails";
import { submitBillingDetails, registerCard } from "./Effects/billingDetails";

export const NAVIGATE_TO_SHOW = 'NAVIGATE_TO_SHOW'
export const NAVIGATE_TO_DETAILS = 'NAVIGATE_TO_DETAILS'
export const NAVIGATE_TO_CARD = 'NAVIGATE_TO_CARD'

export const createActions = (dispatch, state) => ({
  navigateToIndex: () => dispatch({ type: NAVIGATE_TO_SHOW }),
  navigateToDetails: () => dispatch({ type: NAVIGATE_TO_DETAILS }),
  navigateToCard: () => dispatch({ type: NAVIGATE_TO_CARD }),
  submitBillingDetails: async (values) => {
    const billable = await submitBillingDetails(state, {
      contact_name: values.contactName,
      contact_email: values.contactEmail,
      contact_phone: values.contactPhone,
      company_vat: values.companyVat,
      address_attributes: {
        city: values.city,
        code: values.code,
        country: values.country,
        line_1: values.line1,
        line_2: values.line2,
        line_3: values.line3,
        suburb: values.suburb,
      }
    })
    if (!!billable) {
      dispatch({ type: NAVIGATE_TO_SHOW, payload: { billable, address: billable.address }})
    }
  },
  initiateCheckout: async () => {
    const result = await initiateCheckout(state)

    if (!!result.checkout) {
      dispatch({ type: NAVIGATE_TO_CARD, payload: { checkout: result.checkout }})
    } else {
      return false;
    }
  },
  registerCard: async (values) => {
    const billable = await registerCard(state, {
      cardNumber: values.cardNumber,
      cardHolder: values.cardHolder,
      expiryMonth: values.expiryMonth,
      expiryYear: values.expiryYear,
      cvv: values.cvv,
    })
    if (!!billable){
      dispatch({ type: NAVIGATE_TO_SHOW, payload: { billable }})
    }
  },
  removeCard: async () => {
    const result = await removeCard(state)

    if (!!result.billable) {
      dispatch({ type: NAVIGATE_TO_SHOW, payload: { billable: result.billable }})
      return true;
    } else {
      return false;
    }
  }
})